import { Box, Grid, Paper } from "@mui/material";
import Header from "./Header";
import {
  PAGE_SHELL_HEADER_SX,
  PAGE_SHELL_PAPER_SX,
} from "../utils/pageLayoutStyles";

/**
 * Standard page chrome — matches Organization Utilities / Manage Subscription:
 * outer Paper border, heading inset above tabs/content.
 */
const PageShell = ({
  title,
  subtitle,
  headerRight = null,
  children,
  paperSx = {},
  hideHeader = false,
}) => (
  <Grid container>
    <Paper sx={{ ...PAGE_SHELL_PAPER_SX, ...paperSx }}>
      {!hideHeader && (title || subtitle || headerRight) && (
        <Box
          sx={{
            ...PAGE_SHELL_HEADER_SX,
            ...(headerRight
              ? {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 2,
                  flexWrap: "wrap",
                }
              : {}),
          }}
        >
          {(title || subtitle) && (
            <Header title={title} subtitle={subtitle} />
          )}
          {headerRight}
        </Box>
      )}
      {children}
    </Paper>
  </Grid>
);

export default PageShell;
